import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IState } from '@/Module/Store/Model';
import type { IGetTeacherListByCategoryId } from '@/Module/Teacher/Model/ApiModel';
import type { ITeacherListByCategory } from '@/Module/Teacher/Model/DataModel/ITeacherListByCategory';
import { TeacherService } from '@/Module/Teacher/Service';
import { categoryTeacherListSelectByCategoryId } from '@/Module/Teacher/Store/Selector';

export const getTeacherListByCategoryIdAction = createAsyncThunk<
  IGatewayResponse<ITeacherListByCategory>,
  IGetTeacherListByCategoryId['categoryId']
>('teacher/teacherListByCategoryId', async (categoryId, { signal, getState }) => {
  const category = categoryTeacherListSelectByCategoryId(getState() as IState, categoryId)!;

  return TeacherService.getTeacherListByCategoryId(
    {
      categoryId,
      pageNo: category.page,
      pageCount: category.pageRows,
    },
    signal,
  ).then(({ data }) => data);
});
